import { useEffect, useRef, useState } from 'react';

interface CountdownProps {
  startIso: string | null;
  durationSec: number;
  onExpire?: () => void;
  className?: string;
}

export function getVotingRemainingSec(startIso: string | null, durationSec: number): number {
  if (!startIso) return durationSec;
  const start = new Date(startIso).getTime();
  if (Number.isNaN(start)) return durationSec;
  return Math.max(0, durationSec - (Date.now() - start) / 1000);
}

function format(seconds: number): string {
  const safe = Math.max(0, Math.floor(seconds));
  const m = Math.floor(safe / 60)
    .toString()
    .padStart(2, '0');
  const s = (safe % 60).toString().padStart(2, '0');
  return `${m}:${s}`;
}

export default function Countdown({
  startIso,
  durationSec,
  onExpire,
  className,
}: CountdownProps) {
  const [remaining, setRemaining] = useState<number>(() => getVotingRemainingSec(startIso, durationSec));
  const onExpireRef = useRef(onExpire);
  const firedRef = useRef(false);
  useEffect(() => {
    onExpireRef.current = onExpire;
  });

  useEffect(() => {
    firedRef.current = false;
    setRemaining(getVotingRemainingSec(startIso, durationSec));
    const t = setInterval(() => {
      const next = getVotingRemainingSec(startIso, durationSec);
      setRemaining(next);
      if (next <= 0 && !firedRef.current) {
        firedRef.current = true;
        clearInterval(t);
        onExpireRef.current?.();
      }
    }, 250);
    return () => clearInterval(t);
  }, [startIso, durationSec]);

  return <span className={className}>{format(remaining)}</span>;
}
